import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { AccountService } from "../services/account.service";
import { map } from "rxjs";
import { LoginPageComponent } from "./login-page/login-page.component";
import { RouteUtils } from "projects/common/src/lib/route.utils";

@Injectable()
export class AuthenticatedGuard implements CanActivate {
    public constructor(
        private accountService: AccountService,
        private router: Router,
    ) { }

    public canActivate(route: ActivatedRouteSnapshot) {
        return this.accountService.isLoggedIn$.pipe(
            map((isLoggedIn) => isLoggedIn || this.getRedirectUrlTree(route)),
        );
    }

    private getRedirectUrlTree(route: ActivatedRouteSnapshot) {
        const destUrl = this.router.parseUrl(LoginPageComponent.Path);
        if (route.routeConfig?.path) {
            const url = RouteUtils.resolveRoute(route.routeConfig.path, route.params, route.queryParams);
            const redirect = this.router.parseUrl(url);

            destUrl.queryParams["redirectUrl"] = btoa(redirect.toString());
        }

        return destUrl;
    }
}
